import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { Button } from '@mui/material';

import useIsWindowFocused from 'hooks/useIsWindowFocused';

const PREFIX = 'SessionCountdown';

const classes = {
  container: `${PREFIX}-container`,
  heading: `${PREFIX}-heading`,
  description: `${PREFIX}-description`,
  footer: `${PREFIX}-footer`,
  timer: `${PREFIX}-timer`,
  label: `${PREFIX}-label`,
  value: `${PREFIX}-value`,
  cancel: `${PREFIX}-cancel`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.container}`]: {
    position: 'relative',
    padding: '1rem 1.5rem',
    [theme.breakpoints.up('sm')]: {
      padding: '1rem 3rem',
    },
    backgroundColor: theme.colorTokens.onSecondaryFixedVariant,
    color: theme.palette.primary.contrastText,
  },

  [`& .${classes.heading}`]: {
    marginTop: 0,
    fontSize: '24px',
    fontWeight: 400,
  },

  [`& .${classes.description}`]: {
    margin: 0,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: theme.palette.primary.contrastText,
  },

  [`& .${classes.footer}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    marginTop: '1rem',
  },

  [`& .${classes.timer}`]: {
    fontSize: '16px',
    fontWeight: 700,
  },

  [`& .${classes.label}`]: {
    textUnderlineOffset: '2px',
  },

  [`& .${classes.value}`]: {
    paddingLeft: '2px',
  },

  [`& .${classes.cancel}`]: {
    fontSize: 14,
    fontWeight: 700,
    padding: '8px 30px',
    borderRadius: '2rem',
    textTransform: 'inherit',
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      padding: '4px 20px',
    },
  },
}));

export const SessionCountdown = compose(
  inject('store'),
  observer,
)(({ store }) => {
  const { deliveryStore } = store;
  const { delivery, tokenRemainingTimeString, countdownTimer } = deliveryStore;
  const isTabActive = useIsWindowFocused();

  useEffect(() => {
    if (isTabActive) {
      deliveryStore.recalculateTimer();
    } else {
      clearInterval(countdownTimer);
    }
  }, [isTabActive]);

  if (!delivery) return null;

  return (
    <Root className={classes.container}>
      <h3 className={classes.heading}>Manage Your Delivery</h3>
      <p className={classes.description}>
        You have just entered Manage Delivery session, please update your delivery details before the session time expires!
      </p>
      <div className={classes.footer}>
        <div className={classes.timer}>
          <span className={classes.label}>Session time</span>:<span className={classes.value}>{tokenRemainingTimeString}</span>
        </div>
        <Button
          type="button"
          size="small"
          variant="outlined"
          color="inherit"
          disableElevation
          className={classes.cancel}
          onClick={() => deliveryStore.openExitSessionDialog()}
        >
          Exit session
        </Button>
      </div>
    </Root>
  );
});
